const storage = {
    not_configured: "Le fournisseur de stockage n'est pas configuré.",
    missing_parameter: 'Paramètre manquant {{parameter}} pour le fournisseur de stockage.',
    upload_error: "Échec de l'envoi du fichier au fournisseur de stockage.",
};
export default Object.freeze(storage);
